import { Box, Card, CardContent, Grid, makeStyles, Theme, Typography } from '@material-ui/core'
import React, { useState } from 'react'
import _ from 'lodash';
import { IModuleType, Module } from 'src/models';
import { useHistory } from 'react-router';
import { ToolsEnum } from 'src/shared/enum';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
      display: 'flex',
      minWidth: 275,
      maxWidth: 275,
      minHeight: 200,
      justifyContent: 'center',
      paddingTop: 6
    },
    details: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: "center"
    },
    content: {
      flex: '1 0 auto',
    },
    cursorPointer: {
        cursor: "pointer"
    }
  }));

const Dashboard = () => {

    const classes = useStyles();
    const [modules] = useState<IModuleType[]>(_.values(Module));
    const history = useHistory();
    const { t } = useTranslation();

    const getModuleDescription = (module: IModuleType) => {
        switch (module.name) {
            case ToolsEnum.EFileAnalyzer:
                return t('message-efile-analyzer-description')
            case ToolsEnum.RealSizeViewer:
                return t('message-realsize-viewer-description')
            case ToolsEnum.Geocoder:
                return t('message-geocoder-description')
            case ToolsEnum.UnitConverter:
                return t('message-unit-converter-description')
            case ToolsEnum.VolumetricWeight:
                return t('message-volumetric-weight-description')
            default:
                return ""
        }
    }
    
    return (
        <>
            <Grid container spacing={4}>
                {modules.filter(m => m?.children)[0]?.children?.map(module => (
                    <Grid className={classes.cursorPointer} item justifyContent="center" onClick={() => module.url && history.push(module.url)}>
                        <Card className={classes.root}>
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Box>
                                        <module.icon style={{width: "60px", height: "60px"}} />
                                    </Box>
                                    <Box style={{marginTop: "4px"}}>
                                        <Typography component="h6" variant="h6">
                                            {module.name}
                                        </Typography>
                                    </Box>
                                    <Box>
                                        <Typography variant="subtitle2">{getModuleDescription(module)}</Typography>
                                    </Box>
                                </CardContent>
                            </div>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </>
    )
}

export default Dashboard